import { FeatureHeader } from "@/shared/components/custom/FeatureHeader";
import { Button } from "@/shared/components/ui/button";
import { UserPlus, Users } from "lucide-react";

interface CharacterHeaderProps {
    characterCount: number;
    onAddCharacter: () => void;
    showAddButton: boolean;
}

const CharacterHeader = ({
    characterCount,
    onAddCharacter,
    showAddButton
}: CharacterHeaderProps) => {
    return (
        <FeatureHeader
            className="p-8 pb-0"
            title={
                <div className="flex items-center gap-3">
                    <Users className="w-10 h-10 text-primary" />
                    <span>Characters</span>
                </div>
            }
            subtitle={`${characterCount} Character${characterCount !== 1 ? 's' : ''} in this story`}
            actions={
                <>
                    {showAddButton && (
                        <Button onClick={onAddCharacter} className="shadow-lg" size="sm">
                            <UserPlus className="w-4 h-4 mr-2" />
                            New Character
                        </Button>
                    )}
                </>
            }
        />
    )
}

export default CharacterHeader
